import './footer.scss'

function Footer() {
    return (
        <div className="footer">
            <p>&copy; Copyright 2022, GRUVVE. All Rights Reserved.</p>
        </div>
    )
}

export default Footer